// extracted by mini-css-extract-plugin
module.exports = {"title":"LegalNotices_title__3L8Mp","button":"LegalNotices_button__3c9rU","html":"LegalNotices_html__1RWFU"};